/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { DescriptionFieldProps } from '@rjsf/utils';
import Markdown from 'markdown-to-jsx';

/**
 * Custom DescriptionFieldTemplate that renders descriptions as Markdown.
 * This enables support for bold, italic, links, and other Markdown formatting
 * in `ui:description` and schema `description` fields.
 */
export const DescriptionFieldTemplate: React.FC<DescriptionFieldProps> = ({ id, description }) => {
  if (!description) {
    return null;
  }

  if (typeof description === 'string') {
    return (
      <div id={id} className="field-description text-sm text-color-secondary mb-2">
        <Markdown>{description}</Markdown>
      </div>
    );
  }

  // If description is already a ReactElement, render it as-is
  return (
    <div id={id} className="field-description text-sm text-color-secondary mb-2">
      {description}
    </div>
  );
};
